import React from 'react';

import LeadConversationsContextProvider from './LeadConversationsContextProvider';

const withLeadConversationsContext = (Component) => (props) => (
  <LeadConversationsContextProvider>
    <Component {...props} />
  </LeadConversationsContextProvider>
);

export default withLeadConversationsContext;
